import { render } from "./HeroiconsSolidChevronLeft.vue?vue&type=template&id=3b0b58ea"
const script = {}

import exportComponent from "C:\\Users\\ernes\\.ssh\\bipay-laravel-reportes\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChevronLeft.vue"]])

export default __exports__